module.exports = __webpack_public_path__ + "img/talon.ff4df336.jpg";